import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import {
  RANKING_REGULAMENTO_PER_COLABORADOR_KEY,
  getRankingRegulamentoPerColaboradorDocumentsSnapshot
} from "@/modules/ranking-de-colaboradores/firestore";
import useUserStore from "@/modules/users/store";

type TGetRankingRegulamentoPerColaborador = Awaited<
  ReturnType<typeof getRankingRegulamentoPerColaboradorDocumentsSnapshot>
>;

/**
 * Get historicoPontosPerColaborador from the current regulamento from the active empresa
 * @param regulamento - The regulamento to get the historicoPontosPerColaborador
 * @returns - historicoPontosPerColaborador from the current regulamento from the active empresa
 */
function useGetRankingRegulamentoPerColaborador(regulamento: TRegulamentoIdeias) {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  return useQuery<TGetRankingRegulamentoPerColaborador, FirestoreError, TRankingRegulamentoPerColaborador[]>({
    queryKey: [activeEmpresaId, RANKING_REGULAMENTO_PER_COLABORADOR_KEY, { regulamento }],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }

      return getRankingRegulamentoPerColaboradorDocumentsSnapshot(activeEmpresaId, regulamento);
    },
    select(data) {
      if (data.empty) {
        return [];
      }

      return data.docs.map((document_) => document_.data());
    }
  });
}

export default useGetRankingRegulamentoPerColaborador;
